import React from 'react';
import {
  Group,
  Header as CLHeader,
  useWindowProperties,
  H6,
  Stack,
  H8,
  H5,
} from '@qred/components-library';
import { LanguageItemHeader } from './LanguageItemHeader';
import { CountryCode } from '~/enums';
import { useAppShellContext } from '~/components/shared/Navigation/AppShell.context';
import { useAccount } from '~/hooks/useAccount';
import AccountMenu from './AccountMenu';
import useTranslate from '~/hooks/useTranslate';
import { useLocation } from 'react-router-dom';

interface HeaderProps {
  keepDesktopStyle?: boolean;
}

const Header = ({ keepDesktopStyle }: HeaderProps) => {
  const { market, user } = useAccount();
  const { isMobile } = useWindowProperties();
  const isQeld = market === CountryCode.NL;
  const ctx = useAppShellContext();
  const t = useTranslate();
  const location = useLocation();
  const isDashboardPage = location.pathname === '/';

  return (
    <CLHeader
      keepDesktopStyle={keepDesktopStyle}
      mt={keepDesktopStyle ? -16 : undefined}
      mb={keepDesktopStyle ? 16 : undefined}
      mx={keepDesktopStyle ? -16 : undefined}
      style={keepDesktopStyle ? { zIndex: 0 } : { zIndex: 1 }}
      qeld={isQeld}
    >
      <Group justify="space-between" align="center" mx={40} h="100%">
        <Stack align="flex-start" spacing={4}>
          {isDashboardPage ? (
            <>
              <H8>{ctx.headerTitle}</H8>
              <H6>
                {t('NewDashboard.Hello')} {user.firstName + ' ' + user.lastName}
              </H6>
            </>
          ) : (
            <H5>{ctx.headerTitle}</H5>
          )}
        </Stack>
        {!isMobile && (
          <Group align="center">
            {!isQeld && <LanguageItemHeader />}
            <AccountMenu />
          </Group>
        )}
      </Group>
    </CLHeader>
  );
};

export default Header;
